import { render, staticRenderFns } from "./mo-datepicker-wrapper.html?vue&type=template&id=27521d1e&external"
import script from "./mo-datepicker-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-datepicker-wrapper.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/2/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27521d1e')) {
      api.createRecord('27521d1e', component.options)
    } else {
      api.reload('27521d1e', component.options)
    }
    module.hot.accept("./mo-datepicker-wrapper.html?vue&type=template&id=27521d1e&external", function () {
      api.rerender('27521d1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-datepicker-wrapper/mo-datepicker-wrapper.vue"
export default component.exports